import { useRef, useState } from "react";
import Webcam from "react-webcam";
import { Card, Container, Spinner } from "react-bootstrap";
import frame from "../../../images/photo-frame.png";
import {
  dataURLToFile,
} from "../../../help-service/utils";
import candidateService from "../../../service-api/candidateService";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

export default function MobilePhotoTaker({ setShowPhotoTaker,candidateId }) {
  const params = useParams();
  const webcamRef = useRef(null);
  const [step, setStep] = useState("start");
  const [captured, setCaptured] = useState(null);
  const [loading, setLoading] = useState(false);

  const capture = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      setCaptured(imageSrc);
      setStep("preview");
    }
  };

  const saveCandidatesPhoto = () => {
    if (captured) {
      setLoading(true);
      const file = dataURLToFile(captured, "candidate_photo.png");
      candidateService
        .saveCandidatePhoto(candidateId, file)
        .then((res) => {
          console.log("Photo saved successfully:", res);
          setShowPhotoTaker(false);
        })
        .catch((err) => {
          toast.error("Error saving photo:", err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };
  

  return (
    <Container className="d-flex flex-column align-items-center mt-4  min-vh-100 bg-light photo-taker">
      {step === "start" && (
        <Card className="step-1 p-4 shadow-sm text-center w-100">
          <h5 className="mb-2 info-text ">Profile Photo</h5>
          <hr />
          <p className="mb-4 info-text">
            Please ensure your photo clearly displays your face
          </p>
          <div
            className="d-flex align-items-center justify-content-center mx-auto mb-4  rounded-circle"
            // style={{ width: "300px", height: "300px" }}
          >
            <img src={frame} alt="frame" height="100%" width="100%" />
          </div>
          <div className="text-center">
            <button
              className="btn btn-primary w-50 btn-blue border-none fs-6"
              onClick={() => setStep("camera")}
            >
              Take Photo
            </button>
          </div>
        </Card>
      )}
      {step === "camera" && (
        <div
          className="position-relative bg-dark rounded-2 w-100"
          style={{ maxWidth: "350px", height: "500px" }}
        >
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/png"
            className="w-100 h-100 object-fit-cover"
            videoConstraints={{ facingMode: "user" }}
          />
          <div
            className="position-absolute top-50 start-50 translate-middle border border-4 border-white rounded-circle"
            style={{ width: "280px", height: "280px" }}
          />
          <div className="position-absolute start-50 translate-middle-x  ">
            <button
              onClick={capture}
              className="capture-button shadow-sm mt-5"
            />
          </div>
        </div>
      )}
      {step === "preview" && (
        <Card className="p-4 shadow-sm text-center w-100">
          <h5 className="mb-3 info-text">Your Photo</h5>
          <hr />
          <img
            src={captured}
            alt="captured"
            className="rounded mb-4 w-100 shadow-sm"
          />
          <div className="d-flex gap-2 justify-content-center mb-3">
            <button
              className="btn btn-outline-primary w-50 outline-primary"
              onClick={() => setStep("camera")}
            >
              Recapture
            </button>
            <button
              className="btn btn-danger w-50"
              onClick={() => {
                setCaptured(null);
                setStep("camera");
              }}
            >
              Delete
            </button>
          </div>
          <div className="text-center mt-5">
            <button
              className="btn btn-primary w-50 btn-blue border-none fs-6"
              onClick={saveCandidatesPhoto}
              disabled={loading}
            >
              {loading ? (
                <span className="me-2">
                  <Spinner animation="border" size="sm" />
                </span>
              ) : null}
              Next
            </button>
          </div>
        </Card>
      )}
    </Container>
  );
}
